import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeleteCardComponent } from 'src/app/components/shared/delete-card/delete-card.component';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss']
})
export class PaymentMethodsComponent {

  userCards: any[] = [];


  constructor(
    private userService: UserService,
    private auth: AuthenticationService,
    private dialog: MatDialog,
    private router: Router,
     private location: Location,
  ) { }

  ngOnInit(): void {
    this.getUserCards();
  }


  getUserCards() {
    this.userService.getSavedCardsUser().subscribe((data: any) => {
      const cards = data.data || [];
      this.userCards = cards.map((card: any) => ({
        ...card,
        last4: card.last4 || card.pan || 'XXXX'
      }));
    });
  }

  deleteCard(card: any) {
    const dialogRef = this.dialog.open(DeleteCardComponent, {
      width: '600px',
      data: card
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getUserCards();
      }
    });
  }

  backTab() {
    localStorage.setItem('previousUrl', this.router.url);
    this.location.back();
  }
}
